import axios from "axios";

export const enableMocks = false;
let BASE_URL = process.env.REACT_APP_BACKEND_DNS ?? "http://localhost:8080";

if (enableMocks) {
  BASE_URL = "https://starsforcare.free.mockoapp.net";
}

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});
